import { ref } from 'vue';
import api from '@/api/axios';

export function useApi() {
  const data = ref(null);
  const loading = ref(false);
  const error = ref(null);

  const fetchData = async (url, options = {}) => {
    loading.value = true;
    error.value = null;
    try {
      const response = await api.get(url, options);

      if (response.data && response.data.error === true) {
        throw new Error(response.data.message || 'Fetch data failed');
      }

      data.value = response.data;

      return response.data;

    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'API Error';
      const errorMsg = (typeof msg === 'string') ? msg : 'Dữ liệu không hợp lệ';
      error.value = errorMsg;
      const customErr = new Error(errorMsg);
      customErr.response = err.response;
      throw customErr;
    } finally {
      loading.value = false;
    }
  };

  const postData = async (url, payload, options = {}) => {
    loading.value = true;
    error.value = null;
    try {
      const response = await api.post(url, payload, options);

      if (response.data && response.data.error === true) {
        const serverMsg = response.data.message || 'Lỗi từ hệ thống';
        error.value = serverMsg;
        throw new Error(serverMsg);
      }

      data.value = response.data;
      return response.data;

    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'API Error';
      const errorMsg = (typeof msg === 'string') ? msg : 'Dữ liệu không hợp lệ';
      error.value = errorMsg;
      const customErr = new Error(errorMsg);
      customErr.response = err.response;
      throw customErr;
    } finally {
      loading.value = false;
    }
  };

  const putData = async (url, payload, options = {}) => {
    loading.value = true;
    error.value = null;
    try {
      const response = await api.put(url, payload, options);

      if (response.data && response.data.error === true) {
        throw new Error(response.data.message || 'Update failed');
      }

      data.value = response.data;
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'API Error';
      const errorMsg = (typeof msg === 'string') ? msg : 'Dữ liệu không hợp lệ';
      error.value = errorMsg;
      const customErr = new Error(errorMsg);
      customErr.response = err.response;
      throw customErr;
    } finally {
      loading.value = false;
    }
  };

  const patchData = async (url, payload, options = {}) => {
    loading.value = true;
    error.value = null;
    try {
      const response = await api.patch(url, payload, options);

      if (response.data && response.data.error === true) {
        throw new Error(response.data.message || 'Patch failed');
      }

      data.value = response.data;
      return response.data;
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message || 'API Error';
      error.value = errorMsg;
      const customErr = new Error(errorMsg);
      customErr.response = err.response;
      throw customErr;
    } finally {
      loading.value = false;
    }
  };

  const deleteData = async (url, options = {}) => {
    loading.value = true;
    error.value = null;
    try {
      const response = await api.delete(url, options);

      if (response.data && response.data.error === true) {
        throw new Error(response.data.message || 'Delete failed');
      }

      data.value = response.data;
      return response.data;
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message || 'API Error';
      error.value = errorMsg;
      const customErr = new Error(errorMsg);
      customErr.response = err.response;
      throw customErr;
    } finally {
      loading.value = false;
    }
  };

  return { data, loading, error, fetchData, postData, putData, patchData, deleteData };
}